import { render } from "./ContactsList.vue?vue&type=template&id=b4b03a2e"
import script from "./ContactsList.vue?vue&type=script&lang=js"
export * from "./ContactsList.vue?vue&type=script&lang=js"

import "./ContactsList.vue?vue&type=style&index=0&id=b4b03a2e&lang=css"
script.render = render

export default script